/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actual_Cute_Manatee_BloomInputs */

const fr_actual_cute_manatee_bloom = /** @type {(inputs: Actual_Cute_Manatee_BloomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pour une meilleure expérience et avoir les notifications directement sur votre téléphone, installer le site sur votre téléphone`)
};

/**

* @param {Actual_Cute_Manatee_BloomInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const actual_cute_manatee_bloom = /** @type {((inputs?: Actual_Cute_Manatee_BloomInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actual_Cute_Manatee_BloomInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_actual_cute_manatee_bloom(inputs)
});